import { render, staticRenderFns } from "./AutoPostBoostingCampaign.vue?vue&type=template&id=3a286961&"
import script from "./AutoPostBoostingCampaign.vue?vue&type=script&lang=ts&"
export * from "./AutoPostBoostingCampaign.vue?vue&type=script&lang=ts&"
import style0 from "./AutoPostBoostingCampaign.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports